import Vue from 'vue'
import Router from 'vue-router'

import Download from "@/components/Download"
import Help from "@/components/Help"

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/download"
    },
    {
      path: '*',
      redirect: "/download"
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js